export default function isPdfFile(fileUrl, fileType) {
  if (!fileUrl) return false;
  if (fileType && fileType === "application/pdf") return true;
  // If VC, check if the fileUrl is a PDF
  if (fileType && fileType === "VC") {
    return (
      fileUrl.toLowerCase().includes(".pdf") ||
      fileUrl.startsWith("data:application/pdf")
    );
  }
  const normalizedUrl = fileUrl.toLowerCase();
  return (
    normalizedUrl.includes(".pdf") ||
    fileUrl.startsWith("data:application/pdf") ||
    normalizedUrl.includes("application%2fpdf") ||
    normalizedUrl.includes("application/pdf")
  );
}
